import React, { useEffect, useState } from "react";
import { Form, Container, Row, CardGroup } from 'react-bootstrap';
import MiniCardActivityComponent from "./MiniCardActivityComponent";
import HelperMetiers360 from "../../services/HelpersMetiers360";

const ActivityBoardComponent = (props) => {
    const { activities, readOne: readOneSlug, createBlacklistModal, sortTypePreferenceTuple } = props;

    const [activityBoardSortType, setActivityBoardSortType] = sortTypePreferenceTuple ?? [null, null];
    const [sortedActivities, setSortedActivities] = useState([]);

    const sortType = [];
    activities?.some(a => a.publishedAt) && sortType
        .push({
            value: 'publishedAt', label: "Publication (plus récente d'abord)", method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.publishedAt, b.publishedAt)
        });;
    activities[0]?.title !== undefined && sortType
        .push({ value: 'title', label: 'Titre', method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.title, b.title) })
    activities?.some(a => a.duration) && sortType
        .push({
            value: 'duration', label: "Durée", method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.duration, b.duration, true)
        });

    const [sort, setSort] = useState(
        (sortType.find(type => type.value === activityBoardSortType)) ||
        (sortType[0] ?? { value: 'publishedAt', label: "Publication (plus récente d'abord)", method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.publishedAt, b.publishedAt) })
    );

    useEffect(() => {
        if (activities?.length && sort?.method) {
            setSortedActivities([...activities].sort(sort.method));
        }
    }, [sort, activities]);


    const sortChoice = (e) => {
        const sortSelected = sortType.filter(type => type.value === e.target.value)[0];
        setSort(sortSelected);
        // eslint-disable-next-line no-unused-expressions
        setActivityBoardSortType?.(sortSelected.value);
    };

    const checkSort = sortType.map(
        (type, index) => <Form.Check inline name="sort" label={type.label} type='radio'
            value={type.value} key={type.value} id={type.value} onChange={sortChoice} checked={sort.value === type.value} />
    );

    return (
        <Container fluid>
            <Row className="mb-4"><div className="d-flex justify-content-between check-sort">{checkSort}</div></Row>
            <Row>
                <CardGroup className="justify-content-around">
                    {sortedActivities
                        .map(activity => {
                            return (
                                <div key={activity.uniqueId ?? activity.code}>
                                    <MiniCardActivityComponent
                                        activity={activity}
                                        readOneSlug={readOneSlug ? readOneSlug.replace(':uniqueId', activity.uniqueId) : null}
                                        createBlacklistModal={createBlacklistModal}
                                    />
                                </div>
                            )
                        })}
                </CardGroup>
            </Row>
        </Container>
    );
}
export default ActivityBoardComponent;